import { ClientUser } from '@weblite/ts-action/client-user'
import { createKeyvalStorage, createKeyvalView } from '../lib/keyval.storage'

const key = 'client-user'

export const clientUserStorage = createKeyvalStorage<ClientUser>(key)

export const clientUserView = createKeyvalView<ClientUser>(key)
